import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_LOCATION_PERMISSION = `${API_URL}/api/v1/parent/device-permission`;
export const CREATE_LOCATION_DATA = `${API_URL}/api/v1/parent/location-geofencing`;
export const EDIT_LOCATION_DATA = `${API_URL}/api/v1/parent/edit-geofence-location`;

export const GET_LOCATION_DATA = `${API_URL}/api/v1/parent/get-geofence-data`;
export const DELETE_GEOFENCE_DATA = `${API_URL}/api/v1/parent/delete-geofence`;

export function getLocationPermission(payload) {
  return axiosInstance({
    url: GET_LOCATION_PERMISSION,
    method: "GET",
    params: payload,
  });
}

export function createLocationData(payload) {
  return axiosInstance({
    url: CREATE_LOCATION_DATA,
    method: "POST",
    data: payload,
  });
}

export function editLocationData(payload) {
  return axiosInstance({
    url: EDIT_LOCATION_DATA,
    method: "PUT",
    data: payload,
  });
}

export function getGeoFenceData(payload) {
  return axiosInstance({
    url: GET_LOCATION_DATA,
    method: "GET",
    params: payload,
  });
}

export function deleteGeoFenceData(payload) {
  return axiosInstance({
    url: DELETE_GEOFENCE_DATA,
    method: "PUT",
    data: payload,
  });
}
